export default __webpack_public_path__ + "static/media/curation.8b57992e.svg";